import React from "react"
import styled from "styled-components"
import { media } from "utils/Media"

const ArticleStyled = styled.article`
    overflow:hidden;
    header {
        .breadcrumb {
            margin: 22px 0 20px;
            font-size: 1rem;/*16*/
            line-height: 1;
            color: ${props => props.theme.colors.secondary};

            @media ${media.md} {
                margin: 39px 0 29px;
            }  

            a {
                color: ${props => props.theme.colors.secondary};
                font-size: ${props => props.theme.font.size.base};
                font-family: ${props => props.theme.font.family.bold};
                text-decoration: underline;
                &.article-link {
                    color: ${props => props.theme.colors.secondary};
                }
            }
        }
        h1 {
            font-size: 1.5rem;/*24*/
            line-height: 1;
            color: #323741;
            margin: 16px 0 23px;
            text-transform: uppercase;
            @media ${media.md} {
                font-size: 2.25rem;/*36*/
                line-height: 1.11;
                margin: 29px 0 36px;
            }  

            button {
                color: ${props => props.theme.colors.secondary};
            }
        }
    }
    .sidebar {
        aside {
            /* display: flex;
            flex-wrap: wrap;
            justify-content: center; */
            padding: 15px;

            @media ${media.lg} {
                padding: 0;
            }

            a {
                display: block;
                width: 100%;
            }
        } 
    }
    .hero-image {
        margin-bottom: 22px;
        @media ${media.md} {
            margin-bottom: 30px;
        }  
        .gatsby-image-wrapper {
            height: 179px;
            margin: 0 -15px;
            @media ${media.md} {
                height: 399px;
                margin: 0;
            }  
            @media ${media.lg} {
                height: 444px;
            }
        }
    }
    figcaption {
        margin: 5px 0 0;
        font-size: 0.875rem;/*14*/
        line-height: 1.5;
        color: #313742;
        p {
            margin: 0;
            font-size: 1em;
        }
    }
    .date-share {
        margin-bottom: 22px;
        overflow: hidden;
        p.date {
            float: left;
            width: 50%;
            font-family: ${props => props.theme.font.family.base};
            font-size: 1rem;/*16*/
            line-height: 1.5;
            color: #323741;
            margin: 0;
            @media ${media.md} {
                float: none;
                width: 100%;
                margin-bottom: 20px;
            }  
        }
        div.share {
            /* float: right; */
            /* width: 50%; */
            /* text-align: right; */
            font-size: 17px;
            float: none;
            width: 100%;
            text-align: left;
            color: ${props => props.theme.colors.secondary};
            
            .share-button {
                display: inline;
                margin-right: 25px;
                cursor: pointer;
                @media ${media.md} {
                    margin: 0 25px 0 0;
                }  
            }

            p {
                margin: 0 0 .5rem 0;
                font-size: 14px;
                color: ${props => props.theme.colors.blackOff};
                font-family: ${props => props.theme.font.family.base};
            }

            svg {
                max-width: 25px;
                max-height: 25px;
            }
        }
    }
    p {
        margin: 0 0 2em;
        color: #313742;
        line-height: 1.5;
    }
    h2,h3,h4,h5,h6 {
        font-family: ${props => props.theme.font.family.bold};
        font-size: 1.125rem;/*18*/
        /* margin: 3em 0 1.5em; */
        margin: 0 0 1.5rem 0;
    }
    .wp-block-embed-youtube {
        position: relative;
        height: 0;
        &.wp-embed-aspect-16-9 {
            padding-bottom: 56.25%;
        }
        &.wp-embed-aspect-4-3 {
            padding-bottom: 75%;
        }
        iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    blockquote {
        border-left: 3px solid ${props => props.theme.colors.secondary};
        margin-left: 35px;
        padding-left: 13px;
        @media ${media.md} {
            margin-left: 67px;
            padding-left: 24px;
        }
        @media ${media.lg} {
            margin-left: 77px;
            padding-left: 25px;
        }
        p {
            font-family: ${props => props.theme.font.family.italic};
            font-size: 0.875rem;/*14*/
            line-height: 1.5;
            color: #323741;
            em {
                text-transform: uppercase;
                font-size: 1rem;/*16*/
            }
        }
    }
    ul {
        list-style-type: none;
        padding-left: 24px;
        margin-bottom: 2em;
        li {
            position: relative;
            line-height: 1.5;
            color: #313742;
            &:before {
                content: '';
                position: absolute;
                width: 10px;
                height: 10px;
                border-radius: 50%;  
                background-color: ${props => props.theme.colors.secondary};
                top: 7px;
                left: -24px;
            }
        }
    }
    ol {
        li {
            padding-bottom: 1rem;
        }
    }
    iframe {
        width: 100% !important;
    }
`

const Article = (props) => {
    return(
        <ArticleStyled>
            {props.children}
        </ArticleStyled>
    )
}

export default Article